import React from 'react'
import cx from 'classnames'

import { CheckboxCell } from 'components/shared/Table/common/Cells/CheckboxCell/CheckboxCell'

import type { TableRowProps } from 'components/shared/Table/types'
import styles from './TableRow.module.scss'

export const TableRow = ({
  children,
  className,
  type,
  onChange,
  hasCheckbox,
  isChecked = false,
  isIndeterminate = false,
  isSelected = false,
  isHighlighted = false,
  isInactive = false,
  isDisabled = false,
  hide = false,
}: TableRowProps) => (
  <tr
    className={cx(
      styles.row,
      {
        [styles.selected]: isSelected,
        [styles.highlighted]: isHighlighted,
        [styles.inactive]: isInactive,
      },
      className,
    )}
  >
    {hasCheckbox && !hide && (
      <CheckboxCell
        className={styles.checkbox}
        {...{ type, onChange, isChecked, isDisabled, isIndeterminate }}
      />
    )}
    {hide ? null : children}
  </tr>
)
